import React from "react";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import s from "./limitsCustomers.scss";
import cx from "classnames";
import RadioButton from "Components/radiobutton/RadioButton";

export default class System extends React.Component {
  state = {
    viewFields: ["storage"],
    customerSpecificSettingsEnabled: false,
    storage_configuration: "default",
    customer_specific_storage: "",
    customer_specific_storage_error: "",
  };

  componentDidMount() {
    const { customer } = this.props;
    this.deriveInitialState(customer);
  }

  deriveInitialState = (customer) => {
    // customer does not have specific settings
    if (!customer.storage) {
      this.setState({ storage_configuration: "system_settings" });
      return;
    }

    // customer want to user default vpopmail settings
    if (customer.storage === "default") {
      this.setState({ storage_configuration: "default" });
      return;
    }

    this.setState({
      storage_configuration: "customer_specific",
      customer_specific_storage: customer.storage,
      customerSpecificSettingsEnabled: true,
    });
  };

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const config = this.state.storage_configuration;

    if (config === "customer_specific") {
      if (this.state.customer_specific_storage === "" || !this.state.customer_specific_storage) {
        this.setState({
          customer_specific_storage_error: "Il campo non può essere vuoto",
        });
        return;
      }

      if (!this.state.customer_specific_storage.match(/^[A-Za-z0-9]+$/)) {
        this.setState({
          customer_specific_storage_error: "Il campo può contentere solo caratteri alfanumerici",
        });
        return;
      }
    }

    let val = null;
    if (config === "customer_specific") {
      val = this.state.customer_specific_storage;
    } else if (config === "default") {
      val = "default";
    } else {
      val = "system_settings"; // use system settings
    }

    this.props.setFormFieldValue({ storage: val }, () => {
      this.setState({ customer_specific_storage_error: null });
      this.props.submitForm(e, this.state.viewFields);
    });
  };

  handleStorageConfigChange = (val) => {
    this.setState({
      storage_configuration: val.storage_configuration,
      customerSpecificSettingsEnabled: val.storage_configuration === "customer_specific",
      customer_specific_storage:
        val.storage_configuration == "customer_specific" ? this.state.customer_specific_storage : "",
    });
  };

  handleCustomerSpecificStorageChange = (val) => {
    this.setState({ customer_specific_storage: val.customer_specific_storage });
  };

  generatePreview = () => {
    const base = this.props.customer.storage_base_path;
    const config = this.state.storage_configuration;

    if (config === "default") {
      return base;
    }

    if (config === "system_settings") {
      if (this.props.defaultStorage === "default") return base;

      return base + this.props.defaultStorage;
    }

    if (config === "customer_specific") {
      return "/home/vpopmail/" + this.state.customer_specific_storage;
    }
  };

  render() {
    const { isFormLoading, customer } = this.props;

    return (
      <form className={s.general} method="post" onSubmit={this.handleSubmit}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>

          <div className={s.infoBtnGroup}>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">Vpopmail</div>
              <div className="sectionDesc">Configura dove i domini di questo cliente vengono creati</div>
            </div>
            <div className="formsSectionSP">
              <div className={cx("inputFull2 boxSP notAvailableSP")}>
                <div className="inputFull2">
                  <WarningBanner
                    info
                    color="yellow"
                    msg={`I domini di questo utente verranno creati a questo path: ${this.generatePreview()}`}
                  />
                </div>

                <RadioButton
                  className="inputFull2"
                  children={[
                    {
                      value: "default",
                      label: `Rispetta impostazioni vpopmail (solitamente ${customer.storage_base_path})`,
                    },
                    {
                      value: "system_settings",
                      label: `Rispetta le impostazioni impostate da admin per tutti gli utenti (nel db: settings.vpopmail_base: "${this.props.defaultStorage}")`,
                    },
                    {
                      value: "customer_specific",
                      label:
                        "Imposta un path specifico per tutti i domini di questo utente (ATTENZIONE: il path deve prima essere creato sul server)",
                    },
                  ]}
                  name="storage_configuration"
                  value={this.state.storage_configuration}
                  onChange={this.handleStorageConfigChange}
                />

                <div className="inputFull2" style={{ paddingLeft: "2rem" }}>
                  <Input
                    disabled={!this.state.customerSpecificSettingsEnabled}
                    label="Indirizzo storage personalizzate per questo utente"
                    name="customer_specific_storage"
                    placeholder=" "
                    onChange={this.handleCustomerSpecificStorageChange}
                    value={this.state.customer_specific_storage}
                    errors={this.state.customer_specific_storage_error}
                    blockedTextStart={customer.storage_base_path}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
